rhm.dropdown_item = (function (module) {
  'use strict';

  var classes = {
    active: 'dropdown--active',
    trigger: 'dropdown__item',
  };

  var selectors = {
    trigger: '.dropdown__item',
    dropdown: '.dropdown',
    active_dropdown: '.dropdown--active',
    option: '.cart__item__qty__list button',
  };

  function closest(el, sel) {
    if (!el || !el.closest) return null;
    return el.closest(sel);
  }

  document.querySelectorAll(selectors.trigger).forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var parent = trigger.parentElement;
      if (!parent) return;
      parent.classList.toggle(classes.active);
      document.querySelectorAll(selectors.trigger).forEach(function (other) {
        if (other !== trigger && other.parentElement) {
          other.parentElement.classList.remove(classes.active);
        }
      });
    });
  });

  document.querySelectorAll(selectors.option).forEach(function (btn) {
    btn.addEventListener('click', function () {
      var dd = closest(btn, selectors.dropdown);
      if (dd) dd.classList.toggle(classes.active);
    });
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.nodeType) return;
    if (closest(t, selectors.trigger)) return;
    if (closest(t, selectors.dropdown)) return;
    document.querySelectorAll(selectors.active_dropdown).forEach(function (el) {
      el.classList.remove(classes.active);
    });
  });

  module = {};
  return module;
})(rhm.dropdown_item);
